import { z } from "zod";

/**
 * Names the organization a request applies to.
 *
 * Only a super admin may use it to reach another tenant: they have no
 * organization of their own, so on a write it is required rather than
 * optional. For everyone else the scope comes from the session, and naming a
 * different organization is rejected rather than ignored — a client trying to
 * widen its scope gets told, instead of quietly receiving its own data back.
 *
 * Used both as a list filter and as a field on create payloads.
 */
export const tenantScopeSchema = z.object({
  organizationId: z.uuid().optional(),
});

export type TenantScope = z.infer<typeof tenantScopeSchema>;
